import "./ProjectCardStyles.css";
import React from "react";
import { FaArrowRight } from "react-icons/fa";
import { NavLink } from "react-router-dom";

const ProjectCard = (props) => {
  return (
    <div className="project-card">
      <div className="project-card-header">
        <span className="project-number">{props.number}</span>
        <NavLink to={props.view} className="project-icon" style={{ background: props.iconColor }}>
          <FaArrowRight />
        </NavLink>
      </div>
      <h2 className="project-title">{props.title}</h2>
      <p className="project-desc">{props.text}</p>
    </div>
  );
};

export default ProjectCard;